<div class="kiosk-build-versions">
  <div class="row mb-3 align-items-center">
    <div class="col-md-7">
      <div *ngIf="staleCount() > 0" class="alert alert-danger py-2 px-3 mb-2 d-flex align-items-center gap-2">
        <nb-icon icon="alert-triangle-outline"></nb-icon>
        <strong>{{ staleCount() }} kiosk{{ staleCount() === 1 ? '' : 's' }} running a stale build</strong>
        — compare Frontend commit against production below.
      </div>
    </div>
    <div class="col-md-5">
      <div class="d-flex align-items-center justify-content-end flex-wrap gap-2">
        <nb-toggle [(checked)]="autoRefreshEnabled" (checkedChange)="toggleAutoRefresh()" status="primary">
          Auto-refresh
        </nb-toggle>
        <span *ngIf="autoRefreshEnabled" class="text-muted small">Next in {{ countdown }}s</span>
        <button class="btn btn-outline-secondary btn-sm" (click)="loadTablets()">
          <nb-icon icon="refresh-outline"></nb-icon>
          Refresh
        </button>
      </div>
    </div>
  </div>

  <div class="alert alert-warning d-flex align-items-start gap-2 mb-4">
    <nb-icon icon="info-outline"></nb-icon>
    <div class="small">
      <strong>Do not trust the kiosk version footer alone.</strong>
      The webapp footer shows <code>API:</code> and a build date fetched at runtime from the backend —
      they look correct even on a badly stale kiosk.
      Only the <strong>Frontend:</strong> commit (reported here as <em>Build commit</em>) identifies the actual bundle.
    </div>
  </div>

  <nb-card class="mb-3" *ngIf="prodBuildCommit">
    <nb-card-body class="py-2">
      <span class="text-muted small">Production build commit:</span>
      <code class="ms-2">{{ prodBuildCommit }}</code>
    </nb-card-body>
  </nb-card>

  <div *ngIf="endpointUnavailable" class="alert alert-info mb-4">
    <strong>Backend not ready</strong> — {{ errorMessage }}
  </div>

  <nb-card>
    <nb-card-body class="p-0">
      <div *ngIf="isLoading" class="text-center p-4">
        <nb-spinner size="large"></nb-spinner>
        <p class="mt-2 text-muted">Loading online kiosks…</p>
      </div>

      <div *ngIf="!isLoading && errorMessage && !endpointUnavailable" class="text-center p-4">
        <p class="text-danger">{{ errorMessage }}</p>
        <button class="btn btn-outline-secondary btn-sm" (click)="loadTablets()">Try again</button>
      </div>

      <div *ngIf="!isLoading && !errorMessage && tablets.length === 0" class="text-center p-4">
        <nb-icon icon="monitor-outline" style="font-size: 2.5rem;" class="text-muted mb-2"></nb-icon>
        <h5>No kiosks online for this store</h5>
        <p class="text-muted">Kiosks appear here when connected. Build commit is reported via socket registration and X-App-Build header.</p>
      </div>

      <div class="table-responsive" *ngIf="!isLoading && tablets.length > 0">
        <table class="table table-hover mb-0">
          <thead class="table-light">
            <tr>
              <th>Terminal</th>
              <th>Build commit (Frontend)</th>
              <th>Build date</th>
              <th>Flavor</th>
              <th>Connected since</th>
              <th>Build status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tablet of tablets"
              [class.stale-row]="tablet.staleVsProd === true"
              [class.not-reporting-row]="!tablet.buildCommit">
              <td>
                <strong>{{ tablet.terminalName || tablet.terminalId }}</strong>
                <div class="text-muted small font-monospace">{{ tablet.terminalId }}</div>
              </td>
              <td class="font-monospace">
                <code *ngIf="tablet.buildCommit">{{ tablet.buildCommit }}</code>
                <span *ngIf="!tablet.buildCommit" class="badge not-reporting-badge">
                  Not reporting build
                </span>
              </td>
              <td class="small">{{ tablet.buildDate || '—' }}</td>
              <td>
                <span class="badge" [class.bg-success]="tablet.flavor === 'prod'" [class.bg-info]="tablet.flavor === 'dev'">
                  {{ tablet.flavor || '—' }}
                </span>
              </td>
              <td class="small text-nowrap">{{ formatTime(tablet.connectedAt) }}</td>
              <td>
                <span *ngIf="tablet.staleVsProd === true" class="badge stale-badge">
                  <nb-icon icon="alert-triangle-outline" class="me-1"></nb-icon>
                  STALE vs prod
                </span>
                <span *ngIf="tablet.staleVsProd === false" class="badge bg-success">Current</span>
                <span *ngIf="tablet.staleVsProd == null && tablet.buildCommit" class="badge unknown-vs-prod-badge"
                  nbTooltip="Production reference commit may be unset — cannot determine staleness">
                  Unknown vs prod
                </span>
                <span *ngIf="!tablet.buildCommit" class="text-muted small">—</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </nb-card-body>
  </nb-card>
</div>
